//
//
//
//
//
//
//
//
//
//
//
//

import { editLayoutState, enterEditMode, exitEditMode, startTouchDetection, stopTouchDetection } from "../utils/EditLayoutMode";
export default {
  name: "EditLayoutButton",
  data: function data() {
    return {
      state: editLayoutState
    };
  },
  methods: {
    toggle: function toggle() {
      if (this.state.active) {
        // fecha o popup que estiver aberto junto com o modo edição
        this.$root.$emit("hideComponent");
        exitEditMode();
      } else {
        enterEditMode();
      }
    }
  },
  mounted: function mounted() {
    startTouchDetection();
  },
  beforeDestroy: function beforeDestroy() {
    stopTouchDetection();
  }
};